import type { PropsWithChildren } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';
import { tss } from 'tss-react/mui';

import { FilterMenu } from './components/FilterMenu';

const useStyles = tss.create(({ theme }) => ({
  filterMenuContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));

export const OverviewPageToolbar = ({ children }: PropsWithChildren) => {
  const { classes } = useStyles();
  const theme = useTheme();

  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  return mobile
    ? (
        <FilterMenu>
          <div className={classes.filterMenuContainer}>{children}</div>
        </FilterMenu>
      )
    : (
        children
      );
};
